import Button from '@/components/Button';
import { Icon, IconVariant } from '@/components/Icon';
import { LottoStatisticsDrawNumber } from '@/components/LottoStatisticsDrawNumber';
import OffLine from '@/components/OffLine';
import OfflinePlaceholder from '@/components/OfflinePlaceholder';
import OnLine from '@/components/OnLine';
import API from '@/config/api';
import apiRequest from '@/helpers/apiRequest';
import createArrayFromNumber from '@/utilities/createArrayFromNumber';
import React from 'react';

export interface IStatsItem {
  drawNumber: number;
  count: number;
}

interface LottoStatisticsState {
  currentSort: string;
  currentShowExtra: number;
  fetched: boolean;
  stats: IStatsItem[];
}

enum StatisticsSort {
  ByDrawNumberAsc = 'Gewinnzahl (Aufsteigend)',
  ByDrawNumberDesc = 'Gewinnzahl (Absteigend)',
  ByFrequencyAsc = 'Häufigkeit (Aufsteigend)',
  ByFrequencyDesc = 'Häufigkeit (Absteigend)',
}

enum ExtraNumber {
  Count = 1,
  DoNotCount = 0,
}
const ShowExtraValues = {
  0: 'ohne Zusatzzahl',
  1: 'mit Zusatzzahl',
};

const sortFunctions = {
  [StatisticsSort.ByDrawNumberAsc]: (a, b) => a.drawNumber - b.drawNumber,
  [StatisticsSort.ByDrawNumberDesc]: (a, b) => b.drawNumber - a.drawNumber,
  [StatisticsSort.ByFrequencyAsc]: (a, b) => a.count - b.count,
  [StatisticsSort.ByFrequencyDesc]: (a, b) => b.count - a.count,
};

export default class LottoStatistics extends React.Component<
  object,
  LottoStatisticsState
> {
  private numbers: number[] = createArrayFromNumber(49);

  constructor(props) {
    super(props);
    this.state = {
      fetched: false,
      currentSort: StatisticsSort.ByDrawNumberAsc,
      currentShowExtra: ExtraNumber.DoNotCount,
      stats: this.numbers.map((num) => ({
        drawNumber: num,
        count: 0,
      })),
    };
  }

  async fetchStatistics() {
    const extraNumber = this.state.currentShowExtra;
    const apiUrl = `${API.stats.lottoStatistics}/0/${extraNumber}`;
    let response;
    try {
      response = await apiRequest(apiUrl);
    } catch (error) {
      console.error('LottoStatistics - fetchStatistics', error);
    }

    if (response) {
      this.setState({
        fetched: true,
        stats: response.counts,
      });
    }
  }

  handleOnChangedSelect = ($event) => {
    const value = $event.target.value;
    if ($event.target.name === 'sort') {
      this.setState({ currentSort: value });
    } else {
      this.setState({ currentShowExtra: +value }, () => this.fetchStatistics());
    }
  };

  componentDidMount() {
    this.fetchStatistics().then();
  }

  private get sortFunction() {
    return sortFunctions[this.state.currentSort];
  }

  render() {
    return (
      <>
        <OffLine>
          <OfflinePlaceholder box={true} />
        </OffLine>
        <OnLine>
          <div className="LottoStatistics box">
            <div className="OptionSelects">
              <div className="OptionSelects__option">
                <span className="OptionSelects__label">Sortieren nach</span>
              </div>
              <div className="OptionSelects__option">
                <Button
                  variant={Button.Variant.Primary}
                  iconPosition={Button.IconPosition.Right}
                  tag={'div'}
                  className="OptionSelects__inputButton"
                  ariaLabel="Gewinnzahlen sortieren"
                >
                  <label htmlFor="sort">{this.state.currentSort}</label>
                  <select
                    id="sort"
                    name="sort"
                    onChange={this.handleOnChangedSelect}
                    value={this.state.currentSort}
                  >
                    {Object.keys(StatisticsSort).map((option, idx) => (
                      <option key={idx} value={StatisticsSort[option]}>
                        {StatisticsSort[option]}
                      </option>
                    ))}
                  </select>
                  <Icon variant={IconVariant.ChevronDown} />
                </Button>
              </div>
              <div className="OptionSelects__option">
                <Button
                  variant={Button.Variant.Primary}
                  iconPosition={Button.IconPosition.Right}
                  className="OptionSelects__inputButton"
                  tag={'div'}
                  ariaLabel="mit oder ohne Zusatzzahl"
                >
                  <select
                    name="show-extra"
                    id="show-extra"
                    onChange={this.handleOnChangedSelect}
                    value={this.state.currentShowExtra}
                    aria-label={`${
                      ShowExtraValues[this.state.currentShowExtra]
                    }`}
                  >
                    <option value={ExtraNumber.DoNotCount}>
                      {ShowExtraValues[ExtraNumber.DoNotCount]}
                    </option>
                    <option value={ExtraNumber.Count}>
                      {ShowExtraValues[ExtraNumber.Count]}
                    </option>
                  </select>
                  {ShowExtraValues[this.state.currentShowExtra]}
                  <Icon variant={IconVariant.ChevronDown} />
                </Button>
              </div>
            </div>
          </div>
          <LottoStatisticsDrawNumber
            stats={this.state.stats.sort(this.sortFunction)}
            isLoading={!this.state.fetched}
          />
        </OnLine>
      </>
    );
  }
}
